export default {
  lang: {
    sale: "Sale",
    title_sale: "매출관리",
    title_estimation: "견적관리",
    title_contract: "수주관리",
    title_trade: "거래명세서관리",
    title_collection: "收款现状",
    title_uncollected: "未收款管理",
    invoice: "세금계산서",
    title_invoice: "invoice",

    buy: "Buy",
    title_buy: "buy",
    title_order: "order",
    title_pay: "pay",
    title_unpaid: "unpaid",

    production: "Production",
    title_production: "production",
    title_plan: "plan",
    title_result: "result",
    title_pack: "pack",
    title_shipment: "Shipment",

    delivery: "delivery",
    construction: "construction",
    goods: "goods",
    express: "express",
    speedy: "speedy",
    progress: "progress",
    shipment: "shipment",

    stock: "Material",
    title_material: "material",
    title_stock: "stock",
    title_stock_history: "stock_history",
    title_delivery: "delivery",
    title_undelivered: "undelivered",
    title_express: "express",
    inbound: "Inbound",
    title_inbound: "Inbound",

    as: "A/S",
    title_as: "A/S Management",
    title_as_accept: "A/S Accept Management",
    title_calendar: "A/S Calendar",
    title_collection_as: "A/S Collection",

    title_receipt_list: "A/S Receipt List",
    title_instruction_list: "A/S Job Instruction List",
    title_completion_list: "A/S Job Completion List",
    title_billing_list: "A/S Billing List",
    title_as_dialog: "Add Own Products Login",

    department: "Department",
    product_ownership_list: "Product Ownership List",
    code: "code",
    operator_log_in_or_modify: "A/S operator log in or modify",

    workplace: "Workplace",
    account_classification: "Bill sort",
    bill_cost: "Discount price",
    DC_amount: "DC Amount",
    amount_received: "Collected price",
    collection_date: "Collection Date",
    whether_collect: "Whether collect",
    bill_amount: "Bill amount",

    production_number: "Production number",
    installation_site: "Installation site",
    receipt_date: "Receipt date",
    access_date: "Access date",
    address: "Address",
    receiver: "Receiver",
    fault_symptom: "Fault symptom",
    cost: "cost",
    person_in_charge: "Person in charge",
    work_item: "Work item",
    list_update: "list update",
    search_period: "search period",

    management: "Management",
    title_management: "Management Management",
    title_receivablenote: "받을 어음관리",
    title_purchasenote: "결제 어음관리",

    base: "Base",
    title_base: "기초관리",
    title_code: "Code Management",
    title_customer: "거래처관리",
    title_product: "품목관리",
    title_bom: "품목별BOM관리",
    title_safety: "안전재고관리",
    title_history: "변경이력",
    title_cost: "Cost Management",

    system: "System",
    title_system: "System Management",
    title_user: "User",
    title_group: "User Group",
    title_task: "Task Management",
    title_process: "Process Management",

    code_type: "Code Type",
    product: "Product",
    customer: "Customer",
    estimation: "Estimation",
    contract: "Contract",
    process: "Process",
    task: "Task",
    transaction: "Transaction",

    code_rule: "Create Rule",

    base_price: "base price",

    No: "No",
    product_number: "product number",
    product_name: "product name",
    classify: "classify",
    material_name: "material name",
    material_classification: "material classification",
    quantity: "quantity",
    unit: "unit",
    search: "search",
    please_choose: "please choose",
    unitEA: "EA",
    user_id: "Id",
    user_name: "Name",
    user_tel: "Tel",
    user_group: "Group",
    last_login: "Last login time",
    notes: "Notes",

    created_at: "Creation date",
    created_user_name: "Creator",
    modified_at: "Modification date",
    modified_user_name: "Modifier",
    desc: "비고",
    login_users: "Login users number",
    final_reviser: "Final reviser",
    final_reviser_date: "Final reviser date",
    group_name: "Group name",
    have_authority: "Have authority",
    no_authority: "No authority",
    task_name: "Task Name",
    task_user: "Task User",
    logged_person: "Logged Person",
    logged_date: "Logged Date",
    task_login: "Task Login",

    initial_login_date: "Initial Login Date",
    process_name: "Process Name",
    work_number: "Work Number",
    loginer: "Loginer",
    change_date: "Change Date",
    process_work_list: "Process Work List",
    order: "Order",
    work_one: "Work One",
    work_two: "Work Two",

    purchase_number: "Purchase number",
    id: "ID",
    material_color: "Color",
    material_size: "Size",
    warehousing_quantity: "Warehousing quantity",
    current_inventory: "Current inventory",
    warehousing_date: "warehousing date",
    state: "State",

    detail_number: "Detail number",
    whether_issue: "Whether issue",
    customer_name: "Customer name",
    destination: "destination",
    delivery_date: "Delivery date",
    phone_number: "Phone number",
    subscriber: "subscriber",
    shipping_mode: "Shipping mode",

    list_title: "List of transactions",
    issue: "Issue state",
    check: "check",
    list_Packing: "Packing record list",
    placeholder_pack: "No., customer name, destination",
    placeholder_plan: "No., initial login, sales category, product category",

    list_title_plan: "Signed in orders",
    contract_date: "Order date",
    contract_code: "Order code",
    contract_amount: "Order num",
    production_amount: "Production registration",
    specifications: "Specifications",

    list_title_production_plan: "Order list",
    production_plan_date: "Production planDate",
    project_number: "Project number",

    work_instruction_list: "Work instructionList",
    material_number: "Material number",
    current_quantity: "Current quantity",
    safety_stock: "Safety stock",
    production_performance_registration: "Production performanceRegistration",
    label: "Label",
    packing: "Packing",

    material_inventory: "Material inventory",
    content: "Content",
    altered_person: "Altered person",

    sales_classification: "Sales classification",
    product_classification: "Product classification",
    categories: "Categories",
    material_logon: "Material logon",
    classification_composition_login: "Classification compositionLogin",

    indication_quantity: "Indication quantity",
    result_quantity: "Result quantity",
    bad_quantity: "Bad quantity",

    software_consulting:
      "소프트웨어 문의: (주)아브로소프트코리아 [Tel.02-2132-5115]",
    homepage: "http://www.avrosoft.co.kr",

    product_process: "제품공정",
    product_bom: "BOM",
    product_option: "옵션",
    collect: "수금",
    asset: "자산",
    service: "A/S",
    product_price: "제품단가",
    user: "사용자",
    note: "어음",
    size: "규격",
    production_num: "생산번호",
  },
  button: {
    login: "login",
    add: "add",
    search: "search",
    save: "save",
    register: "register",
    modify: "modify",
    delete: "Delete",
    close: "Close",
    yes: "yes",
    no: "no",
    ok: "Ok",
    cancel: "cancel",
    login_modify: "login or modify",

    serachTime: "serachTime",
    password_initialization: "Password initialize",

    packaging_acceptance: "Packaging acceptance",
    packaging_finish: "Packaging finish",
    list_printing: "List printing",
    list_reprint: "List reprint",
    packaging_cancelled: "Packaging cancelled",
    list_update: "List update",

    production_logon: "Production logon",
    production_cancel: "Production cancel",
    production_Internal: "Production Internal",
    production_num: "Production num",

    start_production: "Start production",
    result_login: "Result login",
    bad_login: "Bad login",
    production_completion: "Production completion",
    print_label: "Print label",
    reissued_label: "Reissued label",

    material_inventory: "Material inventory",
    safety_stock_login: "Safety stockLogin",
    manual_shipment: "Manual Shipment",
    cancel_shipment: "Cancel Shipment",
    add_owned_products: "Add Owned Products",
  },
  message: {
    warn_code_total_length:
      "The sum of the digits must not exceed 20 characters.",
    wrong: "wrong",
    cannot_be_repeated: "All works of the project cannot be repeated.",
    must_be_selected: "Work 1 must be selected.",
    please_choose_task_name: "Please choose task name",
    please_choose_task_user: "Please choose task user",
    please_choose_classify: "Please choose classify",
    please_choose_code: "Detail number, Product Name",
    choose_date: "Choose Date",
    please_choose: "Please Choose",
    please_enter_delivery_date: "Please enter delivery date",
    please_enter_customer: "Please enter customer",
    please_enter_code: "Please enter code",
    please_enter_installation_site: "Please enter installation site",
    please_enter_product: "Please enter product",
    please_enter_color: "Please enter color",
    please_enter_size: "Please enter size",
    please_enter_unit: "Please enter unit",
    please_enter_quantity: "Please enter quantity",

    please_enter_the_receiving_date: "Please enter the receiving date",
    please_enter_the_access_date: "Please enter the access date",
    please_select_the_receiver: "Please select the receiver",
    please_enter_the_fault_details: "Please enter the fault details",
    please_enter_price: "Please enter price",
    please_enter_discount_price: "Please enter discount price",
    please_enter_collected_price: "Please enter collected price",
  },
};
